module.exports = __webpack_public_path__ + "static/pseudodragon-1a0624201c4a7782fc82fb33e4d93bff.jpg";